var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{staticClass:"modal--detail--carrier",attrs:{"id":"modalVersionCarrier","title":'Detallado de version',"size":"xl","centered":"","text":"","hide-footer":""}},[_c('body-detail',{attrs:{"detail":_vm.detail}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }